import { apiClient } from './api';
import { Script, CreateScriptData, UpdateScriptData } from '../types/script';

export const scriptService = {
  async getScripts(): Promise<Script[]> {
    const response = await apiClient.get<{ scripts: Script[] }>('/scripts');
    return response.data.data.scripts;
  },

  async createScript(payload: CreateScriptData): Promise<Script> {
    const response = await apiClient.post<{ script: Script }>('/scripts', payload);
    return response.data.data.script;
  },

  async updateScript(id: string, payload: UpdateScriptData): Promise<Script> {
    const response = await apiClient.patch<{ script: Script }>(`/scripts/${id}`, payload);
    return response.data.data.script;
  },

  async deleteScript(id: string): Promise<void> {
    await apiClient.delete(`/scripts/${id}`);
  },
};
